/**
 * État du mode Guide, partagé par le bouton « chemin » (à côté du titre ou au
 * bout des onglets), le volet Savoirs et la couche de repères. Un magasin
 * externe minuscule (useSyncExternalStore) : aucun écran n'a à se passer
 * l'état de main en main.
 *
 *   on      : les repères sont allumés sur la page courante
 *   topic   : sujet en cours de lecture (« Me montrer »), sinon null
 *   step    : étape courante du sujet
 */
import { useSyncExternalStore } from 'react';
import { setLastGuide } from '../../data/progress';

let state = { page: null, on: false, topic: null, step: 0, wasOn: false };
const subs = new Set();
function set(patch) { state = { ...state, ...patch }; subs.forEach((fn) => fn()); }
function subscribe(fn) { subs.add(fn); return () => subs.delete(fn); }
function snapshot() { return state; }

export function useGuide() {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}

export const guide = {
  /* La page change : les repères s'éteignent, sauf si un sujet est en cours,
     dont une étape a pu demander cette navigation. */
  setPage(page) {
    if (page === state.page) return;
    if (state.topic) set({ page });
    else set({ page, on: false, step: 0 });
  },
  toggle() { set({ on: !state.on, topic: null, step: 0 }); },
  off() { set({ on: false, topic: null, step: 0 }); },
  /* « Me montrer » allume les repères le temps de la lecture ; Quitter ou
     Terminer les rendent à l'état où il les a trouvés (2026-09-16) : lancé
     depuis un repère, ils restent ; lancé depuis le panneau, ils s'éteignent.
     Le chemin de la barre reste le seul interrupteur des repères. */
  start(topic) { setLastGuide(topic, 0); set({ on: true, topic, step: 0, wasOn: state.on }); },
  goto(step) { setLastGuide(state.topic, step); set({ step }); },
  end() { set({ topic: null, step: 0, on: state.wasOn }); },
};
